import { Fetch } from 'lib';

import { NoticeDto } from '../../types';

type RequestResponses = {};

type RequestParameters = {};

type RequestBody = {
  notices: NoticeDto[];
};

const updatePublicNotice = async (body: RequestBody) =>
  await Fetch<RequestResponses, RequestParameters, RequestBody>({
    url: 'adminPageBuilder/updatePublicNotices',
    method: 'PATCH',
    body,
  });

export { updatePublicNotice };
